import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconTelephone: React.NamedExoticComponent<CentralIconBaseProps> = React.memo(React.forwardRef<SVGSVGElement, CentralIconBaseProps>((props, ref) => {
  return <CentralIconBase {...props} ref={ref} ariaLabel={"telephone, phone, contact"} maskId="square-filled-radius-0-stroke-1-IconTelephone"><path d="M3 3V5.625C3 14.1164 9.88362 21 18.375 21H21V14.8785L16.1513 12.4541L14.539 14.0664C12.2916 13.1001 10.8999 11.7084 9.93361 9.46099L11.5459 7.84873L9.12152 3H3Z" fill="currentColor"/></CentralIconBase>;
}));

export default IconTelephone;
